import React, { Component } from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';
import cx from 'classnames';
import advancedFiltresSearchRequest from '../../helpers/advancedFiltersSearchRequest';
import { createUrl } from '../../helpers/routerAdapter';
import styles from './ButtonsFormsControls.scss';

class ButtonsFormsControls extends Component {
  shouldComponentUpdate(newProps) {
    const isLocaleChanged = newProps.locale !== this.props.locale;

    return isLocaleChanged;
  }

  handleSubmit = () => {
    const { price } = this.props.fields;
    const routeData = advancedFiltresSearchRequest(this.props.routeData, this.props.fields);
    routeData.params.price = price;
    const route = createUrl(routeData);
    browserHistory.push({ pathname: route, state: routeData });
    this.props.hideAdvancedFilters();
  };

  render() {
    return (
      <div className={styles[this.props.className]}>
        <button
          className={cx(styles.button, styles.clearBtn)}
          onClick={this.props.resetForm}
        >{this.props.translate('clearFilters')}
        </button>
        <button
          className={cx(styles.button, styles.submitBtn)}
          onClick={this.handleSubmit}
        >{this.props.translate('applyFilters')}
        </button>
      </div>
    );
  }
}

ButtonsFormsControls.propTypes = {
  translate: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  fields: PropTypes.object.isRequired,
  routeData: PropTypes.object,
  hideAdvancedFilters: PropTypes.func,
  locale: PropTypes.string
};

export default ButtonsFormsControls;
